import { render, staticRenderFns } from "./advertiseMaterialRequisition.vue?vue&type=template&id=bd0bcbf2&scoped=true&"
import script from "./advertiseMaterialRequisition.vue?vue&type=script&lang=js&"
export * from "./advertiseMaterialRequisition.vue?vue&type=script&lang=js&"
import style0 from "./advertiseMaterialRequisition.vue?vue&type=style&index=0&id=bd0bcbf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0bcbf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd0bcbf2')) {
      api.createRecord('bd0bcbf2', component.options)
    } else {
      api.reload('bd0bcbf2', component.options)
    }
    module.hot.accept("./advertiseMaterialRequisition.vue?vue&type=template&id=bd0bcbf2&scoped=true&", function () {
      api.rerender('bd0bcbf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/advertiseMaterialRequisition.vue"
export default component.exports